'use client';

import { useContext } from 'react';
import { ScreenLayoutContext, type ScreenLayoutContextValue } from './ScreenLayoutContext';

const NO_OP_CONTEXT: ScreenLayoutContextValue = {
  fixedTop: { content: null, title: undefined, className: undefined, height: 0, showBlur: true, motion: 'none' },
  fixedBottom: { content: null, title: undefined, className: undefined, height: 0, showBlur: true, motion: 'none' },
  tabBar: { visible: false, height: 0 },
  disableSafeArea: false,
  isPreview: false,
  layoutReady: true,
  setFixedTop: () => {},
  setFixedBottom: () => {},
  clearFixedTop: () => {},
  clearFixedBottom: () => {},
  setTabBarVisible: () => {},
  clearTabBar: () => {},
  registerTabBarOverride: () => {},
  unregisterTabBarOverride: () => {},
  setDisableSafeArea: () => {},
  registerFixedTopRef: () => {},
  registerFixedBottomRef: () => {},
  registerTabBarRef: () => {},
};

export function useScreenLayout() {
  return useContext(ScreenLayoutContext) ?? NO_OP_CONTEXT;
}
